'use strict';

module.exports = {
    /**
     * 监听截屏事件<br />
     * 使用场景：需要在点击导航条时触发一定条件时调用<br />
     * 对应native接口：navigation.click
     * @method hysdk.onReceiveScreenshot
     * @category Device Event
     * @example ./onNavClick.js[1-53]
     * @description
     *
     * | 运行环境 | 是否支持 |
     * | :-----: | :-----: |
     * | Hy      |   √   |
     * | Hy Browser (qunar) | X    |
     * | Hy Browser (非qunar) | X    |
     * | touch   |   X  |
     * | wechat  |   X   |
     * | ctrip   |   √   |
     *
     */
    receiveScreenshot: {
        hy: {
            key: 'onReceiveScreenshot'
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ../src/events/device.js
// module id = 23
// module chunks = 0 2 4